// What Stripe said went wrong with a card or a bank debit, in the vendor's language: Stripe's code (a card's
// decline_code first — insufficient_funds, expired_card — as the API passes it on, aldoo-na billing failureOf)
// read as one of the portal's texts. A code it has no text for reads as a general refusal, with Stripe's own
// words beside it.
const SAME = {
  invalid_cvc: "incorrect_cvc",
  invalid_number: "incorrect_number",
  invalid_expiry_year: "invalid_expiry_month",
  lost_card: "do_not_honor",
  stolen_card: "do_not_honor",
  pickup_card: "do_not_honor",
  fraudulent: "do_not_honor",
  generic_decline: "do_not_honor",
  restricted_card: "do_not_honor",
  security_violation: "do_not_honor",
  withdrawal_count_limit_exceeded: "card_velocity_exceeded",
  rate_limit: "try_again_later",
  reenter_transaction: "try_again_later",
  issuer_not_available: "try_again_later",
  payment_intent_authentication_failure: "setup_intent_authentication_failure",
  iban_invalid: "invalid_bank_account_iban",
  bank_account_restricted: "debit_not_authorized",
  account_closed: "debit_not_authorized",
}

const TEXTS = (t) => ({
  card_declined: t`The card was declined.`,
  insufficient_funds: t`There is not enough money on the card.`,
  expired_card: t`The card has expired.`,
  incorrect_cvc: t`The card's security code (CVC) is incorrect.`,
  incorrect_number: t`The card number is incorrect.`,
  invalid_expiry_month: t`The card's expiry date is incorrect.`,
  processing_error: t`The bank could not process the payment. Try again in a few minutes.`,
  try_again_later: t`The payment could not go through right now. Try again in a few minutes.`,
  authentication_required: t`Your bank asks to confirm payments with this card. Use another card, or ask your bank to allow payments without confirmation.`,
  setup_intent_authentication_failure: t`Your bank did not confirm the card. Try again.`,
  do_not_honor: t`Your bank declined the card. Contact your bank or use another card.`,
  card_not_supported: t`The card does not support this kind of payment. Use another card.`,
  currency_not_supported: t`The card does not support payments in euro. Use another card.`,
  card_velocity_exceeded: t`The card's limit has been reached. Try again later or use another card.`,
  no_payment_method: t`There is no card on file.`,
  sepa_unsupported: t`Your bank does not accept SEPA direct debits on this account. Add a card for the commission, or use an account at another bank.`,
  invalid_bank_account_iban: t`The IBAN is not valid.`,
  debit_not_authorized: t`Your bank refused the debit from this account.`,
})

/** The text of a Stripe refusal: `code` as the API (or Stripe.js) gives it, `message` Stripe's own words. */
export function stripeErrorText(t, code, message = "") {
  const key = SAME[code] || code
  const text = TEXTS(t)[key]
  if (text) return text
  // a code the portal has no text for: a general refusal, Stripe's words beside it
  return message ? `${t`The payment method was refused.`} (${message})` : t`The payment method was refused.`
}
